export const ELEVATION = 5; // elevation for Material-UI cards (to ensure consistency across the location details)
export const NO_INFO_STRING = 'No information';
